'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, Play, Flame } from 'lucide-react';
import { useSession } from '@/lib/auth-client';
import { useSignInModal } from '@/lib/ui';
import { useTranslation } from '@/lib/locales';
import { useState } from 'react';
export function HeroSectionV2() {
  const $ = _c(7);
  useSession();
  useSignInModal();
  useTranslation();
  const [showVideo, setShowVideo] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-gradient-to-br from-orange-50/60 via-white to-rose-50/40" />;
    t1 = <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-primary-100/30 blur-3xl" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Flame className="w-4 h-4 text-primary-500" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-center gap-2 mb-8">{t2}<p className="text-sm font-medium text-gray-600">Early Preview -{" "}<Link href="/early-preview" className="text-primary-600 underline hover:no-underline cursor-pointer">Learn more</Link></p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div><h1 className="text-4xl sm:text-5xl lg:text-5xl font-extrabold leading-[1.3] mb-6"><span className="box-decoration-clone inline bg-gray-900 text-white px-3 py-1">Helping great products and brands be made, discovered, tried, and purchased.</span></h1><p className="text-xl lg:text-2xl text-gray-600 mb-4">Sizzle helps more people find and experience great product and brands, while helping the brands, retailers, buyers, hosts, and other businesses make more of that happen.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== showVideo) {
    t5 = <section className="relative overflow-hidden bg-white pb-16">{t0}{t1}<div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:py-4">{t3}<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">{t4}<div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-black/5 bg-gray-100 aspect-[4/3]">{showVideo ? <div className="absolute inset-0 flex items-center justify-center bg-black"><p className="text-white text-lg">Video player placeholder</p></div> : <><img src="https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=800&h=600&fit=crop" alt="Food and beverage products being showcased at an activation event" className="w-full h-full object-cover" onError={_temp} /><button onClick={() => setShowVideo(true)} className="absolute inset-0 flex items-center justify-center group/play cursor-pointer" aria-label="Play video"><div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center shadow-xl ring-4 ring-primary-100 group-hover/play:scale-110 transition-transform"><Play className="h-7 w-7 sm:h-8 sm:w-8 text-primary-600 ml-1" /></div></button></>}</div></div></div></section>;
    $[5] = showVideo;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp(e) {
  (e.target as HTMLImageElement).style.display = "none";
  (e.target as HTMLImageElement).parentElement.classList.add("bg-gradient-to-br", "from-orange-200", "via-primary-100", "to-amber-100");
}